<!-- Futurenav Skillprint Section -->
<ngx-spinner aria-hidden="true"></ngx-spinner>
<span class="sr-only" aria-live="polite" role="status">{{ loadingMessage }}</span>
<section class="skillprint-section">
    <div class="section-header">
        <img src="/assets/icons/skillprint-icon.svg" alt="Skillprint" class="section-icon" />
        <h2 class="section-title">Futurenav™ Skillprint</h2>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-state" aria-hidden="true">
        <img src="/assets/animate/beaker-loader-dark.gif" alt="" class="loading-icon">
        <p>Loading your skillprint summary...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !isLoading" class="error-state">
        <p>{{ error }}</p>
        <button class="btn-outline" (click)="loadSkillprintSummary()">Retry</button>
    </div>

    <!-- Content - Only show when data is loaded -->
    <ng-container *ngIf="skillprintSummary && !isLoading && !error">
        <p class="section-description">
            {{ skillprintSummary.summary }}
        </p>

        <div class="skillprint-content">
            <!-- Your Key Strengths -->
            <div class="key-strengths">
                <h3 class="subsection-title">Your Key Strengths</h3>

                <div class="strength-item" *ngFor="let strength of skillprintSummary.strengths">
                    <img src="/assets/icons/thumbs-up.svg" alt="Strength" class="strength-icon" />
                    <div class="strength-details">
                        <h4 class="strength-title">{{ strength.title }}</h4>
                        <p class="strength-description">
                            {{ strength.description }}
                        </p>
                    </div>
                </div>
            </div>

            <!-- Durable Skills Overview -->
            <div class="durable-skills">
                <h3 class="subsection-title">Durable Skills Overview</h3>

                <div class="skill-bar-item" *ngFor="let skillBar of durableSkillBars">
                    <p class="skill-name">{{ skillBar.name }}</p>
                    <div class="skill-threshold-bar">
                        <div class="threshold-segment"
                             *ngFor="let segment of [0, 1, 2, 3]; let i = index"
                             [ngClass]="getSegmentClass(skillBar, i)">
                            <div class="skill-level-label" *ngIf="i + 1 === skillBar.score">
                                <span class="level-text">{{ getSkillLabel(skillBar) }}</span>
                                <div class="info-icon-wrapper"
                                     (mouseenter)="onDurableSkillInfoHover(skillBar)"
                                     (mouseleave)="onDurableSkillInfoLeave()">
                                    <img src="/assets/icons/summary/info-circle.svg"
                                         alt="Info"
                                         class="info-icon"
                                         style="cursor: pointer;">
                                    <div class="custom-tooltip">{{ getSkillDescription(skillBar) }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Top Skills Tags -->
            <div class="top-skills">
                <div class="top-skills-header">
                    <h3 class="subsection-title">Top skills from your resume</h3>
                    <a *ngIf="skillprintSummary.resumeUrl"
                       class="resume-link"
                       (click)="openResumeDialog()">
                        Your resume
                        <img src="/assets/icons/right-arrow-short.svg" alt="" class="resume-link-arrow" />
                    </a>
                </div>
                <div class="skills-tags">
                    <p *ngIf="visibleSkills.length === 0" class="no-skills-message">No skills found</p>
                    <span class="skill-tag"
                        *ngFor="let skill of visibleSkills">{{ skill }}</span>
                    <span *ngIf="!showAllSkills && hasMoreSkills"
                          class="skill-tag more-skills-tag"
                          (click)="toggleShowSkills()">
                        +{{ remainingSkillsCount }} more
                    </span>
                    <span *ngIf="showAllSkills && hasMoreSkills"
                          class="show-less-tag"
                          (click)="toggleShowSkills()">
                        Show less
                    </span>
                </div>


            </div>
        </div>
    </ng-container>
</section>
<!-- Your Assessments Section -->
<section class="assessments-section">
    <h3 class="subsection-title">Your Assessments</h3>
    <div class="assessment-cards">
        <div class="assessment-card">
            <div class="card-content">
                <h4 class="card-title">Career Interest</h4>
                <p class="card-description">Find out what types of careers suit your values.</p>
            </div>
            <button class="btn-outline" (click)="showSurveyResults()">View Insights</button>
        </div>
        <div class="assessment-card">
            <div class="card-content">
                <h4 class="card-title">Communication Skills</h4>
                <p class="card-description">Discover your communication style.</p>
            </div>
            <button class="btn-outline" (click)="openCommunicationAssessment()">
              View Insights 
              <img src="/assets/icons/external-link.svg" alt="External link" class="external-icon">
            </button>
        </div>
        <div class="assessment-card">
            <div class="card-content">
                <h4 class="card-title">Durable Skills</h4>
                <p class="card-description">Learn about your top work-readiness strengths.</p>
            </div>
            <button class="btn-outline" (click)="openBehavioralAssessment()">
              View Insights 
              <img src="/assets/icons/external-link.svg" alt="External link" class="external-icon">
            </button>
        </div>
    </div>
</section>